import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { Typography, Card, Col, Row, Spin} from 'antd'
import instance from '../../utils/API'
import CourseDetails from './CourseDetails'
import ServiceDetails from './ServiceDetails'
import Checkout from '../../components/Checkout'
import Animate from 'rc-animate';
import SignInForm from '../../components/SignInForm'


const { Title, Text} = Typography;

const ProductPage = () => {
    let { type, id } = useParams();
    const user = useSelector(state => state.user)
    const history = useHistory();
    const [product, setProduct] = useState([]);
    const [loading, setLoading] = useState();
    const [error, setError] = useState();

    useEffect(() => {
        if(user.jwt && product.type == "course" && product.priceEur === 0){
            history.push("/course/" + product.id)
        }
        setLoading(true)

        instance(user.jwt).get(type + "/" + id)
            .then(function (response) {
                setProduct(response.data)
                setLoading(false);
            })
            .catch(function (error) {
                setError(true);
                setLoading(false);
            })
    }, [user.jwt]);

    
    if(loading) return (
        <Row justify="center">
                <Col>
                    <Spin
                        size="large"
                        spinning={loading}
                        delay={100}
                    ></Spin>
                </Col>
        </Row>
    )
    return (
        <Animate
            transitionName="fade"
            transitionAppear
        >
        <Row gutter={[16,16]} justify="center">
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                {
                    type === "courses" ? <CourseDetails product={product}/> : <ServiceDetails product={product}/>
                }
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={6}>
            {
                user.jwt ? 
                <Card
                    title={"Payment Details"}
                    style={{
                        borderRadius: 10, 
                        marginBottom: 25,
                        boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)" 
                    }}
                >
                    <Row justify="space-between">
                        <Col><Title level={5}>Product</Title></Col>
                        <Col><Text>{product.title}</Text></Col>
                    </Row>
                    <Row justify="space-between"
                        style={{
                            marginBottom:15,
                            borderBottom: "1px solid #dedede"
                        }}
                    >
                        <Col><Title level={5}>Price</Title></Col>
                        <Col><Text> € {product.priceEur}
                                {product.type == "membership" &&
                                    product.payments == "yearly" ? <> / Year</>
                                    :
                                    product.payments == "monthly" && <> / Month</>
                                }
                        
                        </Text></Col>
                    </Row>

                    <Row>
                    <Title level={5}>Card Details</Title>
                    </Row>
                    <Checkout product={product}/>
                </Card>
                :
                <Card
                    title={"You have to Sign In first"}
                    style={{
                        borderRadius: 10, 
                        marginBottom: 25,
                        boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)" 
                    }}
                >
                    <SignInForm/>
                </Card>
            }
            </Col>
        </Row>
        </Animate>
    )
}

export default ProductPage
